export const BIND_STATUS = {
  notBind: 1, // 未绑定
  auditIng: 2, // 审核中
  hasBind: 3, // 已邦迪
  unBind: 5 // 已解绑
};

export const AUTH_STATUS = {
  isStudent: true,
  notStudent: false
};

export const PAGE_STATUS = {
  activity: 'activity',
  notBind: 'notBind',
  auditIng: 'auditIng',
  auditFailed: 'auditFailed'
};
